import React from "react";
import {Col, ColorPicker, Row, Space} from "antd";
import {ColumnProps} from "antd/es/table";
import Moment from "moment";
const columns: ColumnProps<any>[] = [
  {
    key: "1",
    title: "STT",
    dataIndex: "stt",
    render(value, record, index) {
      return <>{index + 1}</>;
    },
    align: "center",
  },
  {
    key: "2",
    title: "Tên kho",
    dataIndex: "name",
    align: "left",
  },
  {
    key: "3",
    title: "Mô tả",
    dataIndex: "description",
    align: "left",
  },

  {key: "4", title: "Thao tác", dataIndex: "action"},
];
export {columns};
